const initialState = {
    originalPaymentsData: [],
    paymentsState: false,
    paymentsError: false,
    filterPaymentsData: null,
    filterPaymentsState: false,
    addPaymentState: false,
    urlAddPyment: false,
    urlPaymentsAdministrator: false,
    urlContinuePayment: false,
    errorMessage: false

}

export default initialState
